module.exports = __webpack_public_path__ + "static/Privacy-e1ccb24bcfe2690edfb0b2d336fd3845.jpg";